"use client";
import * as React from 'react';
import { wrapper, buttonWrapper, textWrapper, name, secondaryText, icon } from './styles.js';
import { IconButton } from '../../IconButton/IconButton.web.js';
import { Popover } from '../../Popover/Popover.web.js';
import { IconProfile } from '../../icons/ui_general/IconProfile.web.js';
import { colors } from '../../constants/colors.js';
import { usePopover } from '../../Popover/utils.web.js';
import { useTheme } from '../../utils/theming/useTheme.js';
import { Hidden } from '../../Hidden/Hidden.web.js';

/**
 * @deprecated -- Please do not use this component. It is deprecated and will be removed in the future is no longer receiving updates.
 */
var AuthWidget = function AuthWidget(_ref) {
  var _ref$foregroundColor = _ref.foregroundColor,
    foregroundColor = _ref$foregroundColor === undefined ? colors.inkGrey : _ref$foregroundColor,
    _ref$hoverColor = _ref.hoverColor,
    hoverColor = _ref$hoverColor === undefined ? colors.oceanGreen : _ref$hoverColor,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === undefined ? colors.snowWhite : _ref$iconColor,
    _ref$iconBackgroundCo = _ref.iconBackgroundColor,
    iconBackgroundColor = _ref$iconBackgroundCo === undefined ? colors.oceanGreen : _ref$iconBackgroundCo,
    _ref$highlightColor = _ref.highlightColor,
    highlightColor = _ref$highlightColor === undefined ? colors.oceanGreen : _ref$highlightColor,
    userName = _ref.userName,
    children = _ref.children,
    secondaryText$1 = _ref.secondaryText;
  var popover = usePopover();
  var theme = useTheme();
  return /*#__PURE__*/React.createElement(wrapper, {
    "data-testid": "elemental-AuthWidget"
  }, /*#__PURE__*/React.createElement(Hidden, {
    below: "l"
  }, /*#__PURE__*/React.createElement(buttonWrapper, {
    onClick: popover.handleOpen,
    $foregroundColor: foregroundColor,
    $hoverColor: hoverColor,
    theme: theme
  }, /*#__PURE__*/React.createElement(textWrapper, null, /*#__PURE__*/React.createElement(name, null, userName), secondaryText$1 && /*#__PURE__*/React.createElement(secondaryText, {
    "data-testid": "elemental-AuthWidget-secondaryText"
  }, secondaryText$1)), /*#__PURE__*/React.createElement(icon, {
    $size: 24,
    padding: 8,
    color: iconColor,
    $backgroundColor: iconBackgroundColor
  }))), /*#__PURE__*/React.createElement(Hidden, {
    above: "l"
  }, /*#__PURE__*/React.createElement(IconButton, {
    size: 32,
    icon: /*#__PURE__*/React.createElement(IconProfile, {
      size: 24
    }),
    status: "plain",
    color: highlightColor,
    onClick: popover.handleOpen,
    "data-testid": "elemental-AuthWidget-profileButton"
  })), /*#__PURE__*/React.createElement(Popover, {
    onClose: popover.handleClose,
    anchor: popover.anchor,
    opened: popover.open,
    anchorPos: "top-end",
    backgroundColor: colors.lightGrey,
    padding: 0
  }, children));
};

export { AuthWidget };
